import { IMapToolbar } from "./interfaces/IMapToolbar";

export class MapToolbarDefaults implements IMapToolbar {
	public readonly showHomeButton: boolean = false;
	public readonly showPanButton: boolean = false;
	public readonly showCameraActionsButton: boolean = false;
	public readonly showFullScreenToggleButton: boolean = false;
	public readonly showZoomButtons: boolean = true;
	public readonly showRotateButtons: boolean = false;
	public readonly showForceLabelsButton: boolean = false;
	public readonly showLabelsOnZoomButton: boolean = false;

	public static get instance(): IMapToolbar {
		return new MapToolbarDefaults();
	}
}
